import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = { class: "image-delete" }
const _hoisted_3 = { class: "column flex-center q-pa-sm" }
const _hoisted_4 = { class: "absolute-full column flex-center transparent image-gallery-item--error" }
const _hoisted_5 = { class: "text-error" }
const _hoisted_6 = { class: "text-h4 text-navy-base q-pt-sm" }

import { useDialogPluginComponent } from "quasar"
import SfxBtn from "src/components/button/SfxBtn.vue"
import SfxBtnOutline from "src/components/button/SfxBtnOutline.vue"
import { Icons } from "src/util/enums/fontAwesomeIcons"
import { ImageViewerItem } from "src/util/types/components/sfxImageGallery"
import { PropType } from "vue"
import { useI18n } from "vue-i18n"

//region Props and Emits

const imageSize = "Not Working"

//endregion

export default /*#__PURE__*/_defineComponent({
  __name: 'SfxDialogImageDelete',
  props: {
  entity: {
    type: String,
    required: true,
  },

  image: {
    type: Object as PropType<ImageViewerItem>,
    required: true,
  },
},
  emits: [...useDialogPluginComponent.emits],
  setup(__props) {

const props = __props



//endregion

//region Variables

const { t } = useI18n()

const title = t("sfxDialogImageDelete.title")
const body_warning = t("sfxDialogImageDelete.body_warning")
const body_description = t("sfxDialogImageDelete.body_description", { entity: props.entity })
const btnCancel = t("sfxButtons.btn_cancel")
const btnRemove = t("sfxButtons.btn_remove")

const { dialogRef, onDialogOK, onDialogCancel } = useDialogPluginComponent()


return (_ctx: any,_cache: any) => {
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_img = _resolveComponent("q-img")!
  const _component_q_card_actions = _resolveComponent("q-card-actions")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!

  return (_openBlock(), _createBlock(_component_q_dialog, {
    ref_key: "dialogRef",
    ref: dialogRef
  }, {
    default: _withCtx(() => [
      _createVNode(_component_q_card, { class: "q-dialog-plugin sfx-dialog-border-warning" }, {
        default: _withCtx(() => [
          _createVNode(_component_q_card_section, { class: "text-h3 text-negative q-pb-lg" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(title)), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_q_card_section, { class: "text-body1 q-pb-lg" }, {
            default: _withCtx(() => [
              _createElementVNode("span", { innerHTML: _unref(body_description) }, null, 8, _hoisted_1)
            ]),
            _: 1
          }),
          _createVNode(_component_q_card_section, { class: "text-body1 text-negative q-pb-lg" }, {
            default: _withCtx(() => [
              _createElementVNode("b", null, _toDisplayString(_unref(body_warning)), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_q_card_section, { class: "sfx-dialog-list-manager-elements q-pb-none" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _createVNode(_component_q_img, {
                    src: __props.image.src,
                    height: "100px",
                    width: "100px",
                    class: "image-delete--image"
                  }, {
                    error: _withCtx(() => [
                      _createElementVNode("div", _hoisted_4, [
                        _createVNode(_component_q_icon, {
                          name: _unref(Icons).IMAGE_ERROR,
                          class: "text-disabled",
                          size: "25px"
                        }, null, 8, ["name"]),
                        _createElementVNode("i", _hoisted_5, _toDisplayString(_ctx.$t("sfxImage.no_image_small")), 1)
                      ])
                    ]),
                    _: 1
                  }, 8, ["src"]),
                  _createElementVNode("span", _hoisted_6, _toDisplayString(__props.image.attachmentData.name + "." + __props.image.attachmentData.extension), 1),
                  _createElementVNode("span", { class: "text-body2 text-navy-base" }, _toDisplayString(imageSize) + " MB ")
                ])
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_q_card_actions, null, {
            default: _withCtx(() => [
              _createVNode(SfxBtnOutline, {
                onClick: _unref(onDialogCancel),
                label: _unref(btnCancel),
                class: "col"
              }, null, 8, ["onClick", "label"]),
              _createVNode(SfxBtn, {
                onClick: _unref(onDialogOK),
                label: _unref(btnRemove),
                class: "col bg-negative"
              }, null, 8, ["onClick", "label"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 512))
}
}

})